import { parseNestedPath, type PathSegment } from '../base/store/storePathUtils';

/** PathSegment[] → rc-table 路径 (string|number)[] */
export function dataIndexPathToSegments(path: PathSegment[]): (string | number)[] {
  return path.map((s) => s.key);
}

/**
 * 统一列 dataIndex：
 * - 单段字符串（无 `.` / `[]`）→ 原样（兼容扁平字段）
 * - 含 `.` 或 `[]` → parseNestedPath 转数组
 * - array → 数字字符串段转 number
 */
export function normalizeColumnDataIndex(
  dataIndex: unknown,
): string | (string | number)[] | undefined {
  if (dataIndex === null || dataIndex === undefined || dataIndex === '') return undefined;
  if (Array.isArray(dataIndex)) {
    return dataIndex.map((seg) =>
      typeof seg === 'string' && /^\d+$/.test(seg) ? Number(seg) : seg,
    ) as (string | number)[];
  }
  if (typeof dataIndex === 'string') {
    const trimmed = dataIndex.trim();
    if (!trimmed) return undefined;
    if (trimmed.includes('.') || trimmed.includes('[') || trimmed.includes(']')) {
      const segments = parseNestedPath(trimmed);
      if (segments.length === 0) return trimmed;
      return dataIndexPathToSegments(segments);
    }
    return trimmed;
  }
  return String(dataIndex);
}

/** 将规范化后的 dataIndex 转为点路径字符串（用于写回与命令参数） */
export function columnDataIndexToPathString(dataIndex: unknown): string {
  const norm = normalizeColumnDataIndex(dataIndex);
  if (norm === undefined) return '';
  if (Array.isArray(norm)) return norm.map(String).join('.');
  return norm;
}

/**
 * 列设置 / Table 列 identity：空字符串 key 视为未配置，回退 dataIndex。
 * 属性面板未填「列 key」时会落库 key: ""，?? 无法回退，导致列被 filter 掉。
 */
export function resolveTableColumnKey(col: {
  key?: unknown;
  dataIndex?: unknown;
}): string {
  const explicit = col.key;
  if (
    explicit !== null &&
    explicit !== undefined &&
    String(explicit).trim() !== ''
  ) {
    return String(explicit).trim();
  }
  return columnDataIndexToPathString(col.dataIndex);
}
